import { findByRelationStrict } from "api/utils"

export default entity => findByRelationStrict(entity, ["i18n"]) || {}
